import React, { useContext, useEffect } from "react";
import { Routes as Switch, Route, Navigate } from "react-router-dom";
import General from "../pages/General/General";
import Home from "../pages/Home/Home";
import Navigation from "../pages/Navigation/Navigation";
import Products from "../pages/Products/Products";
import ProductDetails from "../pages/ProductDetails/ProductDetails";
import Pages from "../pages/Pages/Pages";
import Search from "../pages/Search/Search";
import Cart from "../pages/Cart/Cart";
import Favorites from "../pages/Favorites/Favorites";
import Contact from "../pages/Contact/Contact";
import Account from "../pages/Account/Account";
import Categories from "../pages/Categories/Categories";
import SuperCategories from "../pages/SuperCategories/SuperCategories";
import Profile from "../pages/Profile/Profile";
import QRCodePage from "../pages/QRCodePage/QRCodePage";
import Authentication from "../pages/Authentication/Authentication";
import Orders from "../pages/Orders/Orders";
import OrderDetails from "../pages/OrderDetails/OrderDetails";
import Placeholders from "../pages/Placeholders/Placeholders";
import News from "../pages/News/News";
import Publish from "../pages/Publish/Publish";
import { UserContext } from "../context/UserContext";
import { useNavigate, useLocation } from "react-router-dom";
import Plans from "../pages/Plans/Plans";
import HomeServices from "../pages/HomeServices/HomeServices";
import CategoriesServices from "../pages/CategoriesServices/CategoriesServices";
import BookingProcess from "../pages/BookingProcess/BookingProcess";
import YourAppointments from "../pages/YourAppointments/YourAppointments";
import Calendar from "../pages/Calendar/Calendar";
import Services from "../pages/Services/Services";
import ServiceDetails from "../pages/ServiceDetails/ServiceDetails";
import AuthenticationService from "../pages/AuthenticationService.js/AuthenticationService";
import BookingProcessServices from "../pages/BookingProcessServices/BookingProcessServices";
import Colors from "../pages/Colors/Colors";
import Metadata from "../pages/Metadata/Metadata";
import Loyalty from "../pages/Loyalty/Loyalty";
import AccountDeletion from "../pages/AccountDeletion/AccountDeletion";

export default function Routes({
	drawerWidth,
	goToQR,
	setGoToQR,
	goToNavigation,
	setGoToNavigation,
	goToAppearance,
	setGoToAppearance,
	onboardingFinished,
	setOnboardingFinished,
	onboardingStarted,
	setOnboardingStarted,
	goToPages,
	setGoToPages,
	goToHome,
	setGoToHome,
	goToPublish,
	setGoToPublish,
	setRun,
}) {
	const { user } = useContext(UserContext);
	const navigate = useNavigate();
	const { pathName } = useLocation();

	useEffect(() => {
		if (user?.subscription?.status === "incomplete_expired") {
			navigate("/settings");
		}
	}, [navigate, user]);

	useEffect(() => {
		if (
			user?.subscription?.status === "incomplete_expired" &&
			!pathName.includes("settings")
		) {
			navigate("/settings");
		}
	}, [navigate, pathName, user]);

	useEffect(() => {
		if (goToQR) {
			setGoToQR(false);
			navigate("/qr");
		}
	}, [goToQR]);

	return (
		<Switch>
			<Route
				path="/"
				exact
				element={
					<General
						drawerWidth={drawerWidth}
						goToQR={goToQR}
						setGoToQR={setGoToQR}
						onboardingFinished={onboardingFinished}
						setOnboardingFinished={setOnboardingFinished}
						onboardingStarted={onboardingStarted}
						setOnboardingStarted={setOnboardingStarted}
						setRun={setRun}
					/>
				}
			></Route>
			<Route
				path="/qr"
				exact
				element={
					<QRCodePage
						drawerWidth={drawerWidth}
						goToNavigation={goToNavigation}
						setGoToNavigation={setGoToNavigation}
						setRun={setRun}
					/>
				}
			></Route>
			<Route
				path="/navigation"
				exact
				element={
					<Navigation
						drawerWidth={drawerWidth}
						setRun={setRun}
						goToAppearance={goToAppearance}
						setGoToAppearance={setGoToAppearance}
					/>
				}
			></Route>
			<Route
				path="/colors"
				exact
				element={
					<Colors
						drawerWidth={drawerWidth}
						setRun={setRun}
						goToPages={goToPages}
						setGoToPages={setGoToPages}
					/>
				}
			></Route>
			<Route
				path="/pages"
				exact
				element={
					<Pages
						drawerWidth={drawerWidth}
						setRun={setRun}
						goToHome={goToHome}
						setGoToHome={setGoToHome}
					/>
				}
			></Route>
			<Route
				path="/home"
				exact
				element={
					<Home
						drawerWidth={drawerWidth}
						setRun={setRun}
						goToPublish={goToPublish}
						setGoToPublish={setGoToPublish}
					/>
				}
			></Route>
			<Route
				path="/home-services"
				exact
				element={<HomeServices setRun={setRun} drawerWidth={drawerWidth} />}
			></Route>
			<Route
				path="/products"
				exact
				element={<Products drawerWidth={drawerWidth} />}
			></Route>
			<Route
				path="/services"
				exact
				element={<Services drawerWidth={drawerWidth} />}
			></Route>
			<Route
				path="/service-details"
				exact
				element={<ServiceDetails drawerWidth={drawerWidth} />}
			></Route>
			<Route
				path="/product-details"
				exact
				element={<ProductDetails drawerWidth={drawerWidth} />}
			></Route>
			<Route
				path="/search"
				exact
				element={<Search drawerWidth={drawerWidth} />}
			></Route>
			<Route
				path="/categories"
				exact
				element={<Categories drawerWidth={drawerWidth} />}
			></Route>
			<Route
				path="/supercategories"
				exact
				element={<SuperCategories drawerWidth={drawerWidth} />}
			></Route>
			<Route
				path="/categories-services"
				exact
				element={<CategoriesServices drawerWidth={drawerWidth} />}
			></Route>
			<Route
				path="/booking-process"
				exact
				element={<BookingProcess drawerWidth={drawerWidth} />}
			></Route>
			<Route
				path="/booking-process-services"
				exact
				element={<BookingProcessServices drawerWidth={drawerWidth} />}
			></Route>
			<Route
				path="/your-appointments"
				exact
				element={<YourAppointments drawerWidth={drawerWidth} />}
			></Route>
			<Route
				path="/calendar"
				exact
				element={<Calendar drawerWidth={drawerWidth} />}
			></Route>
			<Route
				path="/cart"
				exact
				element={<Cart drawerWidth={drawerWidth} />}
			></Route>
			<Route
				path="/favorites"
				exact
				element={<Favorites drawerWidth={drawerWidth} />}
			></Route>
			<Route
				path="/loyalty"
				exact
				element={
					<Loyalty
						drawerWidth={drawerWidth}
						setRun={setRun}
						goToPublish={goToPublish}
						setGoToPublish={setGoToPublish}
					/>
				}
			></Route>
			<Route
				path="/contact"
				exact
				element={<Contact drawerWidth={drawerWidth} />}
			></Route>
			<Route
				path="/publish"
				exact
				element={
					<Publish
						drawerWidth={drawerWidth}
						setRun={setRun}
						onboardingFinished={onboardingFinished}
						setOnboardingFinished={setOnboardingFinished}
					/>
				}
			></Route>
			<Route
				path="/authentication"
				exact
				element={<Authentication drawerWidth={drawerWidth} />}
			></Route>
			<Route
				path="/authentication-service"
				exact
				element={<AuthenticationService drawerWidth={drawerWidth} />}
			></Route>
			<Route
				path="/account"
				exact
				element={<Account drawerWidth={drawerWidth} />}
			></Route>
			<Route
				path="/orders"
				exact
				element={<Orders drawerWidth={drawerWidth} />}
			></Route>
			<Route
				path="/order-details"
				exact
				element={<OrderDetails drawerWidth={drawerWidth} />}
			></Route>
			<Route
				path="/placeholders"
				exact
				element={<Placeholders drawerWidth={drawerWidth} />}
			></Route>
			<Route
				path="/settings"
				exact
				element={<Profile drawerWidth={drawerWidth} />}
			></Route>
			<Route
				path="/metadata"
				exact
				element={<Metadata drawerWidth={drawerWidth} />}
			></Route>
			<Route
				path="/news"
				exact
				element={<News drawerWidth={drawerWidth} />}
			></Route>
			<Route
				path="/plans"
				exact
				element={<Plans drawerWidth={drawerWidth} />}
			></Route>
			<Route
				path="/account-deletion"
				exact
				element={<AccountDeletion drawerWidth={drawerWidth} />}
			></Route>
			<Route path="*" element={<Navigate to="/" replace />}></Route>
		</Switch>
	);
}
